import { EChatShareAccessScope } from "@frontend-shared/types";

export const COPY_FEEDBACK_DURATION_MS = 2000;

// NOTE: i18n key for each active-share scope. Keeps the label lookup a single
// map access instead of a nested ternary; a null/undefined scope falls back to
// specific-people (the only scope this dialog creates).
export const SCOPE_LABEL_KEY_BY_SCOPE = {
  [EChatShareAccessScope.PROJECT]: "share.scope_project",
  [EChatShareAccessScope.ORGANIZATION]: "share.scope_organization",
  [EChatShareAccessScope.SPECIFIC_PEOPLE]: "share.scope_specific_people",
} as const;
